module.exports = __webpack_public_path__ + "static/media/optima.bec4ff2b.png";